function toggleReadMore() {
  const readMoreButtons = document.querySelectorAll('.programming2020Container__main__body__content__item__card__read-more');

  readMoreButtons.forEach((button) => {
    const {aboutId} = button.dataset;

    button.addEventListener('click', () => {
      const about = document.querySelector(`#about${aboutId}`);
      const isActive = about.classList.contains('programming2020Container__main__body__content__item__card__about--hiden');

      if (isActive) {
        about.classList.remove('programming2020Container__main__body__content__item__card__about--hiden');
        return;
      }

      about.classList.add('programming2020Container__main__body__content__item__card__about--hiden');
    });
  });
}

window.addEventListener("load", toggleReadMore);
